import React from 'react';
import { Alert as AlertAntd } from 'antd';
import cn from 'classnames';
import type { AlertProps } from './types';
import './style.scss';

export const Alert: React.FC<AlertProps> = ({ className, ...props }) => (
  <AlertAntd {...props} className={cn('alert-default', className)} />
);
